"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12.998 21.415 2.876 11.473a3.252 3.252 0 0 1-.87-2.083L2 3.81c0-.95.77-1.719 1.72-1.719h5.578a3.223 3.223 0 0 1 2.055.843c.016.014.03.03.045.046h.001l10.087 9.92a1.72 1.72 0 0 1 .01 2.442l-6.07 6.07a1.719 1.719 0 0 1-2.414.018l-.014-.014ZM7.157 5.957a1.289 1.289 0 1 0 0 2.578 1.289 1.289 0 0 0 0-2.578Z"
})), "0 0 24 24", "Deals");
exports.default = _default;